module.exports = __webpack_public_path__ + "img/Intelligent_tit.382f1a7b.jpg";